import { Api } from "../Api";
require('dotenv');
const axios = require('axios').default;

let StudentSubmitTimesheetApi = {

    endpoint : "StudentSubmitTimesheet/",

    async add(item) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint;

        const response = await axios.post(URL, item, { withCredentials: true });
        return response.data;
    },

    async update(item) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + item.id;

        const response = await axios.put(URL, null, { withCredentials: true });
        return response.data;
    }
}

//Assign Api Mixin
StudentSubmitTimesheetApi = Object.assign({}, StudentSubmitTimesheetApi);


export { StudentSubmitTimesheetApi }